import React from 'react';
import { findDOMNode } from 'react-dom';

// Deprecated
export default class BaseComponent extends React.Component<any,any> {

    constructor(props) {
        super(props);

        this._bind('addClass','removeClass');
    }

    _bind(...methods) {
        methods.forEach((method)=>{
            try {
                this[method] = this[method].bind(this);
            } catch(err) {
                console.error("BaseComponent","_bind error:", method, err);
            }
        });
    }

    addClass(className, ref?) {
        const node = findDOMNode(ref ? ref : this);
        // @ts-ignore
        if (node) node.classList.add(className);
    }

    removeClass(className, ref?) {
        const node = findDOMNode(ref ? ref : this);
        // @ts-ignore
        if (node) node.classList.remove(className);
    }

    toggleClass(className, value, ref?) {
        value ? this.addClass(className, ref) : this.removeClass(className, ref)
    }
}
